export const ContentActionOptions = {
    required: 'required',
    show: 'show',
    hide: 'hide'
};

export const ConditionsSchema = {
    effect: 'effect',
};
